import CustomBreadcrumbs from '@/custom/components/atoms/CustomBreadcrumbs'
import React from 'react'

export const OverViewLayout = (props) => {
    return (
        <div className="overView">
            <div className="container">
                <CustomBreadcrumbs items={props.breadcrumbs} />
                <h3>{props.title}</h3>
                <p>{props.description}</p>
            </div>
        </div>
    )
}
